"use strict";
var Observable_1 = require('../../Observable');
var startWith_1 = require('../../operator/startWith');
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/startWith.js
// module id = 1025
// module chunks = 3